import { createFileRoute } from "@tanstack/react-router";

import { getBlogIndex } from "@/content/blog";
import { CONTENT_CACHE_CONTROL } from "@/content/cachePolicy";
import { useAppSearchParams } from "@/routing/navigation";
import BlogListingPage from "./-components/BlogListingPage";

export const Route = createFileRoute("/blog/")({
  loader: () => getBlogIndex(),
  /**
   * Every matched route's `headers()` is folded root-first and each name is
   * `set`, so a leaf wins over its layout, and the result goes into the SSR
   * `Response`. `withSecurityHeaders` then copies these onto a fresh `Headers`
   * and sets only the five security names, so this passes through untouched.
   */
  headers: () => ({ "Cache-Control": CONTENT_CACHE_CONTROL }),
  component: BlogListingRoute,
});

function BlogListingRoute() {
  // Read through the URL rather than `validateSearch`: typing one route's
  // search narrows the router's global search type and breaks every call site
  // that passes an untyped object.
  const page = Number(useAppSearchParams().get("page") ?? 1);
  return (
    <BlogListingPage
      posts={Route.useLoaderData()}
      page={Number.isFinite(page) ? page : 1}
    />
  );
}
